import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, Observable, throwError } from "rxjs";
import { AlertService } from "../alert/alert.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private requests: HttpRequest<unknown>[] = [];

  constructor(private _alertService: AlertService) { }

  // Função auxiliar para tratar o caso default
  handleDefaultError(error: any): string {
    const defaultMessage = "Houve um erro desconhecido na Requisição. Tente novamente ou entre em contato com o suporte.";

    // Se não houver error.error.message ou error.statusText, retorna mensagem padrão
    if (!error?.error?.message && !error?.statusText) {
      return defaultMessage;
    }

    // Caso específico da URL
    if (error?.url?.includes("senasp/pessoa-fisica/consulta-externa") && error?.error?.fields?.length) {
      return error.error.fields[0].message;
    }

    // Monta mensagem com error.message e fields, se existirem
    let message = error.error?.message || error.statusText;
    if (error.error?.fields?.length) {
      message += `\n${error.error.fields.map((field: any) => field.message).join("\n")}`;
    }

    return message;
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.requests.push(request);
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = "";

        if (error.error instanceof ErrorEvent) {
          errorMessage = `Erro: ${error}`;
        } else {
          // server-side error
          switch (error.status) {
            case 404: // Not Found
              errorMessage = "Não foi encontrado a requisição";

              if (error.error.message) {
                errorMessage = error.error.message;
              }
              break;
            case 401: //
              errorMessage = "Usuário não autorizado";
              break;
            default:
              errorMessage = this.handleDefaultError(error);
          }
        }

        if (request.headers.get("skip")) {
          return throwError(() => errorMessage);
        }

        if (request.headers.get("observeError")) {
          return throwError(() => error);
        }

        this._alertService.error(errorMessage);
        return throwError(() => errorMessage);
      })
    );
  }
}
